import React from "react";
import ISOCertificationImg from "../../../Assets/ISO Certification/CertificationImg.png";

const ISOContent29990 = () => {
  return (
    <>
      <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
        {/* left side */}
        <div className="w-full">
          {/* heading */}
          <div className="py-4 lg:py-10">
            <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
              <h1 className="mb-3">
                <span className="border-b-4 border-[#249742]">ISO 299</span>
                90:2010
              </h1>
            </div>
          </div>

          {/* content */}
          <div>
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              ISO 29990 specifies basic requirements for providers of learning
              services in non-formal education and training. ISO 29990 is a
              quality management system especially applicable for LSPs.
              Certification against this standard will enhance the quality of
              your offerings and enable you to become the preferred choice of
              your customers. ISO 29990 sets out the criteria for a Quality
              Management System standard for providers of education and training
              services. ISO 29990 provides a unified standard for learning
              service providers, including corporations, vocational
              institutions, and life-long learning centres, around the globe. It
              promotes the design of suitable services & evaluation of learning
              results.
            </p>

            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
                The aim of ISO 29990 is to provide a generic model for quality
                professional practice and performance for learning service
                providers (LSPs) in the development and delivery of education,
                training.
              </p>
            </p>

            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              The standard follows a process-based structure to ensure its
              implementation leads to continual improvement. The standard’s
              ultimate aim is assuring the implementation of high-quality
              tutorial programmes and processes.
            </p>
          </div>
        </div>

        {/* right side */}
        <div className="grid grid-cols-1">
          <div className="py-0 sm:py-8">
            <img
              src={ISOCertificationImg}
              className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
              alt="Compliance certificate"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOContent29990;
